import { createFileRoute, useParams, useNavigate } from '@tanstack/react-router'

function CampaignDetailPage() {
  const { id } = useParams({ strict: false }) as { id: string }
  const navigate = useNavigate()
  if (!id) return null
  return (
    <div className="p-6">
      <h2 className="text-lg font-semibold text-gray-900">Campaign {id}</h2>
      <p className="mt-2 text-sm text-gray-500">
        Campaign detail is managed from the campaigns list. Editing is done inline there.
      </p>
      <button onClick={() => navigate({ to: '/campaigns' })} className="mt-4 text-blue-600 hover:underline">
        ← Back to campaigns
      </button>
    </div>
  )
}

export const Route = createFileRoute('/(admin)/campaigns/$id/')({ component: CampaignDetailPage })
